import '../css/module_articles.scss';

import Collapse from 'bootstrap/js/dist/collapse'
import Modal from 'bootstrap/js/dist/modal'
import Dropdown from 'bootstrap/js/dist/dropdown'

import {doLast} from './module_last';
import { initFirebaseApp } from './module_firebase';
import { manageLogin } from './module_auth_helper';
import {attachTryPremiumSubscribe, funnelUpdateWhenAvailable} from './module_common'
import {defaultCarouselSetupNew, defaultCarouselSetupTwoRow} from './module_swiper';
import { configArticleCard } from './module_article_card';
import { initCardLazyLoad } from './module_lazyload';
import { initNavbar } from './module_header';

import './module_common_actions';

function podcastsCarouselSetUp() {
    const out = "podcasts-out"
    const container = "podcasts-swiper-container"
    defaultCarouselSetupNew(container, out, "auto", 3, 4, 5, podcastSearchEndPoint)  
}

function articleNewsCarouselSetUp() {
    const out = "article-news-out"
    const container = "article-news-swiper-container"
    defaultCarouselSetupTwoRow(container, out, 'auto', 2, 3)
}

function articleRecommendedCarouselSetUp() {
    const out = "article-recommended-out"
    const container = "article-recommended-swiper-container"
    defaultCarouselSetupTwoRow(container, out, 'auto', 2, 3)
}

$(function () {
    initFirebaseApp()
    manageLogin()
    
    doLast()
    initCardLazyLoad()

    attachTryPremiumSubscribe()
    
    initNavbar()
    podcastsCarouselSetUp()
    articleNewsCarouselSetUp()
    articleRecommendedCarouselSetUp()

    configArticleCard()

    if (!isPageReloadedAfterLogin) funnelUpdateWhenAvailable('articles_list_viewed');
});